import { DealStatus } from 'components/common/types/Deal.types';
import { isReadOnly } from 'utils/isReadOnly';

export const isDspDisabled = (bookingStatusCode: DealStatus | string): boolean =>
  isReadOnly(bookingStatusCode) ||
  bookingStatusCode === DealStatus.LIVE ||
  bookingStatusCode === DealStatus.REJECTED ||
  bookingStatusCode === DealStatus.FAILED;
